<template>
  <div class="createSemdReBuy">
    <!-- 头部返回 -->
    <div class="backBox">
      <img
        class="pointer"
        @click="returnBack()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">{{
        isLook ? "查看" : !valueRow || activityData.isCopy ? "创建活动" : "编辑"
      }}</span>
    </div>
    <!-- 表单 -->
    <div class="formBox" :style="isLook ? 'height:calc(100vh - 178px)' : ''">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="0">
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!-- 活动条件表单设置 -->
      <div class="secondstep">
        <el-form
          :model="formData"
          :rules="rules"
          :disabled="isLook"
          ref="formData"
          class="backgroundForm"
          label-width="150px"
        >
          <div class="newsInfo">基本规则</div>
          <el-form-item label="活动名称：" required>
            <el-input
              v-model="formData.activityName"
              maxlength="15"
              show-word-limit
              placeholder="请输入活动名称"
              style="width: 400px"
              :disabled="isStart"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动参与对象：" required prop="partner">
            <el-checkbox-group
              v-model="formData.partner"
              @change="checkListchange"
              :disabled="isStart"
            >
              <el-checkbox label="-1" name="partner">全部</el-checkbox>
              <template v-if="!!levelList && levelList.length >= 0">
                <el-checkbox
                  v-for="(item, index) in levelList"
                  :key="index"
                  :label="index + 1 + ''"
                  :disabled="formData.partner == -1"
                  name="partner"
                  >{{ item }}
                </el-checkbox>
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="活动条件：">
            <el-checkbox
              label="关注店铺后方可参加活动"
              v-model="formData.isOpenCard"
            ></el-checkbox>
          </el-form-item>
          <el-form-item label="活动结束时间：" required>
            <el-date-picker
              v-model="formData.endTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="endTimeOption"
              :default-time="defaultEndTime"
              :disabled="isStart"
              @change="(val) => (formData.endTime = val)"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="停止参与时间：" required>
            <el-date-picker
              v-model="formData.stopJoinTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="stopTimeOption"
              :default-time="defaultEndTime"
              :disabled="isStart"
              @change="(val) => handleStopJoinTIme(val)"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="活动C端背景图：" required>
            <div class="miniAppPic">
              <div class="top">
                <el-upload
                  class="upload"
                  action="/jd-hd-web/image/upload"
                  :show-file-list="false"
                  :before-upload="beforeUpload"
                  :on-success="handleUpload"
                  :disabled="isStart"
                >
                  <el-button size="mideal" class="returnBtn"
                    >自定义上传</el-button
                  >
                </el-upload>
              </div>
              <div class="bottom">
                <el-image class="elImg" :src="formData.picUrl" fit="contain">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-image>
                <div class="tips1">
                  <p>建议上传尺寸：750px * 3200px</p>
                  <p>图片大小：300K以内</p>
                  <p>格式：JPG、PNG</p>
                </div>
              </div>
            </div>
          </el-form-item>

          <div class="newsInfo">下单派样规则</div>
          <el-form-item label="付款时间：" required>
            <el-date-picker
              v-model="formData.payStartTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="payStartTimeOption"
              :default-time="defaultStartTime"
              @change="(val) => (formData.payStartTime = val)"
              :disabled="isStart"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="formData.payEndTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="payEndTimeOption"
              :default-time="defaultEndTime"
              :disabled="isStart"
              @change="(val) => handlePayEndTime(val)"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="派样商品：" required>
            <div class="item-wrap">
              <el-radio
                v-model="formData.sampleProductsType"
                @change="handleProductsType"
                :label="0"
                :disabled="isStart"
              >
                全部商品
              </el-radio>
              <el-radio
                v-model="formData.sampleProductsType"
                @change="handleProductsType"
                :label="1"
                :disabled="isStart"
              >
                指定商品
                <template v-if="formData.sampleProductsType == 1">
                  {{ "(已选" + formData.sampleProductList.length + "个)" }}
                </template>
              </el-radio>
              <template v-if="formData.sampleProductsType == 1">
                <span style="margin-right: 10px">
                  <!-- 查看-商品按钮不禁用 -->
                  <el-form :model="formData" label-width="150px">
                    <el-button
                      style=""
                      type="returnBtn"
                      @click="isShowSelectGoods = true"
                      >选择商品</el-button
                    >
                  </el-form>
                </span>
              </template>
              <el-radio
                v-model="formData.sampleProductsType"
                @change="handleProductsType"
                :label="2"
                :disabled="isStart"
              >
                排除商品
                <template v-if="formData.sampleProductsType == 2">
                  {{ "(已选" + formData.sampleProductList.length + "个)" }}
                </template>
              </el-radio>
              <template v-if="formData.sampleProductsType == 2">
                <span style="margin-right: 10px">
                  <!-- 查看-商品按钮不禁用 -->
                  <el-form :model="formData" label-width="150px">
                    <el-button
                      style=""
                      type="returnBtn"
                      class="zindexBox"
                      @click="isShowSelectGoods = true"
                      >选择商品</el-button
                    >
                  </el-form>
                </span>
              </template>
            </div>
          </el-form-item>
          <el-form-item label="商品件数：" required>
            <el-input
              type="text"
              :maxlength="6"
              v-model="formData.itemTotal"
              clearable
              style="width: 200px"
              @input="(val) => checkputn(val, 'itemTotal')"
              :disabled="isStart"
            ></el-input>
            件
            <span class="red"
              >注：填入数值则用户下单派样商品的件数需≥该数值</span
            >
          </el-form-item>
          <el-form-item label="确认收货时间：" required>
            <el-date-picker
              v-model="formData.finishStartTime"
              disabled
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :default-time="defaultStartTime"
              placeholder="默认显示派件付款开始时间"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="formData.finishEndTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="finishEndTimeOption"
              :default-time="defaultEndTime"
              :disabled="isStart"
              @change="(val) => handleFinishTime(val)"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="收货信息录入时间：" required>
            <el-date-picker
              v-model="formData.enterStartTime"
              disabled
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :default-time="defaultStartTime"
              placeholder="默认显示派件付款开始时间"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="formData.enterEndTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="enterEndTimeOption"
              :default-time="defaultEndTime"
              :disabled="isStart"
              @change="(val) => handleEnterTime(val)"
            >
            </el-date-picker>
          </el-form-item>

          <div
            v-if="permissions.indexOf('hide:hd:prize:sendReBuyPrize') != '-1'"
          >
            <!-- <div
            v-if="permissions.indexOf('hide:hd:prize:sendReBuyPrize') != '-1'"
          > -->
            <div class="newsInfo">派样成功奖品</div>
            <el-form-item label="奖品发放时机：">
              派样商品收货成功
              <el-input
                type="text"
                placeholder="请输入天数"
                :maxlength="6"
                v-model="coupon.dayNum"
                style="width: 100px;"
                clearable
                @input="(val) => new_checkputn(val, 'dayNum')"
                :disabled="isStart"
              ></el-input>
              天后发放
            </el-form-item>
            <el-form-item label="派样成功产品：">
              <div>温馨提示：活动期间，每个用户都只能领取1次</div>
              <el-table
                :data="coupon.sendReBuyPrize"
                style="width: 700px; border: 1px solid #f0f0f0"
                :header-cell-style="{
                  background: '#fafafa',
                  'text-align': 'left',
                }"
                :cell-style="{ 'text-align': 'center' }"
              >
                <el-table-column label="优惠券名称">
                  <template slot-scope="scope">
                    <!-- <span v-if="isStart">{{ scope.row.title }}</span>
                  <span class="s" @click="handleChoise()" v-else-if="scope.row.title">{{ scope.row.title }}</span>
                  <span class="s" @click="handleChoise()" v-else>选择优惠券</span> -->
                    <el-button
                      type="text"
                      style="width: unset"
                      @click="handleChoise(scope.row)"
                      >{{ scope.row.title || "选择优惠券" }}</el-button
                    >
                  </template>
                </el-table-column>
                <el-table-column label="面额" prop="price"> </el-table-column>
                <el-table-column label="使用条件">
                  <template slot-scope="scope" v-if="scope.row.quota">
                    <span> {{ "满" + scope.row.quota + "元可用" }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="发放数量">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.totalAmount"
                      @input="totalAmountInput($event, scope)"
                      @blur="beAdd(scope.row)"
                      placeholder="请输入发放数量"
                      :disabled="isStart"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      v-if="scope.row.title"
                      @click="reSendReBuyPrize"
                      >清空</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </div>

          <div class="newsInfo">回购规则</div>
          <el-form-item label="付款时间：" required>
            <el-date-picker
              v-model="formData.rePayStartTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="rePayStartTimeOption"
              :default-time="defaultStartTime"
              @change="(val) => (formData.rePayStartTime = val)"
              :disabled="isStart"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="formData.rePayEndTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="rePayEndTimeOption"
              :default-time="defaultEndTime"
              :disabled="isStart"
              @change="(val) => handleRePayEndTime(val)"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="活动商品：" required>
            <div class="item-wrap">
              <el-radio
                v-model="formData.reProductsType"
                @change="handleReProductsType"
                :label="0"
                :disabled="isStart"
              >
                全部商品
              </el-radio>
              <el-radio
                v-model="formData.reProductsType"
                @change="handleReProductsType"
                :label="1"
                :disabled="isStart"
              >
                指定商品
                <template v-if="formData.reProductsType == 1">
                  {{ "(已选" + formData.reProductList.length + "个)" }}
                </template>
              </el-radio>
              <template v-if="formData.reProductsType == 1">
                <span style="margin-right: 10px">
                  <!-- 查看-商品按钮不禁用 -->
                  <el-form :model="formData" label-width="150px">
                    <el-button
                      style=""
                      type="returnBtn"
                      @click="isShowReSelectGoods = true"
                      >选择商品</el-button
                    >
                  </el-form>
                </span>
              </template>
              <el-radio
                v-model="formData.reProductsType"
                @change="handleReProductsType"
                :label="2"
                :disabled="isStart"
              >
                排除商品
                <template v-if="formData.reProductsType == 2">
                  {{ "(已选" + formData.reProductList.length + "个)" }}
                </template>
              </el-radio>
              <template v-if="formData.reProductsType == 2">
                <span style="margin-right: 10px">
                  <!-- 查看-商品按钮不禁用 -->
                  <el-form :model="formData" label-width="150px">
                    <el-button
                      style=""
                      type="returnBtn"
                      class="zindexBox"
                      @click="isShowReSelectGoods = true"
                      >选择商品</el-button
                    >
                  </el-form>
                </span>
              </template>
            </div>
          </el-form-item>
          <el-form-item label="单笔订单金额：" required>
            <el-input
              type="text"
              v-model="formData.orderAmt"
              clearable
              style="width: 200px"
              @input="handelInput('orderAmt')"
              :disabled="isStart"
            ></el-input>
            元
            <div class="red">
              <div>1、注：由于接口原因，pop支持统计实付金额，自营仅支持统计订单金额；填入数值则用户下单付款指定商品的单笔订单金额需≥该数值</div>
              <div>2、订单金额是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。</div>
            </div>
          </el-form-item>
          <el-form-item label="确认收货时间：" required>
            <el-date-picker
              v-model="formData.reFinishStartTime"
              disabled
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :default-time="defaultStartTime"
              placeholder="默认显示回购付款开始时间"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="formData.reFinishEndTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              ref="timeBox"
              style="width: 200px; font-size: 12px"
              :picker-options="reFinishEndTimeOption"
              :default-time="defaultEndTime"
              :disabled="isStart"
              @change="(val) => handlereFinishEndTimeTime(val)"
            >
            </el-date-picker>
          </el-form-item>

          <div class="newsInfo">奖品设置</div>
          <el-form-item label="">
            <el-table
              :data="prizeSettingList"
              style="width: 700px; border: 1px solid #f0f0f0"
              :header-cell-style="{
                background: '#fafafa',
                'text-align': 'left',
              }"
              :cell-style="{ 'text-align': 'center' }"
            >
              <el-table-column label="奖品类型">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    style="width: unset"
                    @click="centerVis(scope.row)"
                    >{{ scope.row.title || "选奖品" }}</el-button
                  >
                </template>
              </el-table-column>
              <el-table-column label="值" width="80" prop="price">
              </el-table-column>
              <el-table-column label="奖品总数" width="180">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.totalAmount"
                    placeholder="请输入..."
                    style="width: 70px"
                    @input="
                      scope.row.totalAmount = getNumberData(
                        1,
                        $event,
                        0,
                        1,
                        99999999
                      )
                    "
                    @blur="beAdd(scope.row)"
                    :disabled="isStart && !scope.row.minNum"
                  ></el-input>
                  份
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>

          <div class="newsInfo">分享设置</div>
          <el-form-item label="小程序分享标题：" required>
            <el-input
              type="text"
              style="width: 400px"
              show-word-limit
              v-model="formData.shareTitle"
              :maxlength="28"
              :disabled="isStart"
            ></el-input>
          </el-form-item>
          <el-form-item label="小程序分享简介：" required>
            <el-input
              type="text"
              style="width: 400px"
              show-word-limit
              v-model="formData.shareIntroduce"
              :maxlength="28"
              :disabled="isStart"
            ></el-input>
          </el-form-item>
          <el-form-item label="小程序分享图片：" required>
            <div class="miniAppPic">
              <div class="top">
                <el-upload
                  class="upload"
                  action="/jd-hd-web/image/upload"
                  :show-file-list="false"
                  :before-upload="beforeUpload2"
                  :on-success="handleUpload1"
                  :disabled="isStart"
                >
                  <el-button size="mideal" class="returnBtn"
                    >自定义上传</el-button
                  >
                </el-upload>
                <el-button type="text" @click="picUrlReset1">重置</el-button>
              </div>
              <div class="bottom">
                <el-image class="elImg" :src="formData.sharePic" fit="contain">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-image>
                <div class="tips1">
                  <p>建议上传尺寸：200*200像素</p>
                  <p>图片大小：300KB以内</p>
                  <p>格式：jpg、png</p>
                </div>
              </div>
            </div>
          </el-form-item>
          <div class="newsInfo">活动规则</div>
          <el-form-item label="规则内容:" required>
            <div style="width: 570px">
              <richText
                v-model="formData.ruleDescription"
                :readOnly="isLook"
              ></richText>
            </div>
            <div style="margin-top: 15px">
              <div>
                <el-button
                  type="returnBtn"
                  class="generate"
                  plain
                  @click="generateRule"
                >
                  生成规则
                </el-button>

                <span class="desc">
                  <i class="el-alert__icon el-icon-info"></i>
                  提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
                </span>
              </div>
            </div>
          </el-form-item>

          <div class="newsInfo">活动页悬浮按钮跳转链接设置</div>
          <el-form-item label="悬浮按钮图片：">
            <div class="miniAppPic">
              <div class="top">
                <el-upload
                  class="upload"
                  action="/jd-hd-web/image/upload"
                  :show-file-list="false"
                  :before-upload="beforeUpload3"
                  :on-success="handleUpload3"
                  :disabled="isStart"
                >
                  <el-button size="mideal" class="returnBtn"
                    >自定义上传</el-button
                  >
                </el-upload>
                <el-button type="text" @click="picUrlReset3">重置</el-button>
              </div>
              <div class="bottom">
                <el-image
                  class="elImg"
                  :src="formData.jumpPicUrl"
                  fit="contain"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-image>
                <div class="tips1">
                  <p>建议上传尺寸：150px * 150px</p>
                  <p>图片大小：100KB以内</p>
                  <p>格式：jpg、png</p>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="跳转链接：">
            <el-input
              type="text"
              style="width: 400px;"
              v-model="formData.jumpLink"
              :disabled="isStart"
            ></el-input>
          </el-form-item>

          <div class="newsInfo">活动页说明图：</div>
          <el-form-item label="图片设置：">
            <div class="miniAppPic">
              <div class="top">
                <el-upload
                  class="upload"
                  action="/jd-hd-web/image/upload"
                  :show-file-list="false"
                  :before-upload="beforeUpload"
                  :on-success="handleUpload2"
                  :disabled="isStart"
                >
                  <el-button size="mideal" class="returnBtn"
                    >自定义上传</el-button
                  >
                </el-upload>
              </div>
              <div class="bottom">
                <el-image
                  class="elImg"
                  :src="formData.explainPicUrl"
                  fit="contain"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-image>
                <div class="tips1">
                  <p>建议上传尺寸：750x450像素</p>
                  <p>图片大小不能超过100k</p>
                  <p>类型：JPG、PNG</p>
                </div>
              </div>
            </div>
          </el-form-item>
          <actInfoSetting :valueRow="valueRow" :activityData="activityData" :isKeyActivity.sync="isKeyActivity" :placementPosition.sync="placementPosition"/>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="!isLook">
      <el-button
        class="returnBtn createBtn"
        @click="saveDraft"
        v-if="hasDraftBtn"
        >存为草稿</el-button
      >
      <el-button
        @click="vaildForm"
        class="keepBtn"
        type="primary"
        kai
        size="medium"
        >保存设置</el-button
      >
    </div>

    <!-- 选择奖品弹窗 -->
    <!-- <selectProduct
      v-if="isShowPiontProduct"
      ref="selectPiontProduct"
      :num="1"
      :actId="valueRow"
      :isShowFirst="false"
      :typeDefault="typeDefault"
      :echoDate="echoDate"
      :JingdouCount="JingdouCount"
      @close="colseDialog"
      @choose-shop="getTheData"
    >
    </selectProduct> -->

    <selectGoodsGift
      v-if="isShowPiontProduct"
      ref="selectPiontProduct"
      :echoDate="echoDate"
      @choose-shop="getTheData"
    >
    </selectGoodsGift>
    <!-- 选择实物 -->
    <!-- 派样 -->
    <select-goods
      ref="selectGoods"
      v-if="isShowSelectGoods"
      :isShow="isShowSelectGoods"
      :isEdit="isEdit"
      :moduleType="true"
      :skuSearch="true"
      :xianz="false"
      :selectGoods="formData.sampleProductList"
      @close="selectGoodsChange"
      :disabled="isLook"
    ></select-goods>
    <!-- 复购 -->
    <select-goods
      ref="selectGoods"
      v-if="isShowReSelectGoods"
      :isShow="isShowReSelectGoods"
      :moduleType="true"
      :skuSearch="true"
      :xianz="false"
      :selectGoods="formData.reProductList"
      @close="selectReGoodsChange"
      :disabled="isLook"
    ></select-goods>

    <!-- 添加优惠券 pop -->
    <!-- <add-coupon1
      :fromInfo="echoDate"
      :isSuperFission="true"
      :isShow="addCouponIsShow1"
      :isStart="isStart"
      @close="addCouponIsShow1 = false"
      @funcMes="addStatus1"
    ></add-coupon1> -->
    <!-- 选择优惠券 -->
    <selectPrize
      v-model="addCouponIsShow2"
      @closePrize="addStatus2"
      @close="addCouponIsShow2 = false"
    ></selectPrize>
    <!-- <add-coupon2
      :isShow="addCouponIsShow2"
      @close="addCouponIsShow2 = false"
      @funcMes="addStatus"
    ></add-coupon2> -->

    <!-- 保存并完成设置弹框 -->
    <el-dialog
      title="重要提示"
      v-if="showSetDialog"
      :visible.sync="showSetDialog"
      width="800"
      @close="showSetDialog = false"
    >
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSetDialog = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import richText from "@/components/richText.vue";
import selectGoods from "@/components/selectGoodsMonitor2.vue";
import selectGoodsGift from "./select_goodsGift";
import selectProduct from "./select_product.vue";
import selectPrize from "./select_prize.vue";

import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import {
  saveActivity,
  getSendReBuyDetail,
} from "@/api/integralCenter/PointActivityAnalyticController";
import { getTaobaoItemListSku } from "@/api/analysis/ware-controller";
import addCoupon1 from "./add_coupon1";
import addCoupon2 from "./add_coupon2";

export default {
  components: {
    draggable,
    richText,
    selectProduct,
    selectGoods,
    selectGoodsGift,
    addCoupon1,
    addCoupon2,
    selectPrize,
  },
  props: {
    // 当前行数据 修改数据时
    valueRow: {
      type: Object,
      default: () => {
        return null;
      },
    },
    // 当前活动数据
    activityData: {
      type: Object,
    },
    // 是否是查看数据
    isLook: {
      type: Boolean,
      default: false,
    },
    // 当前活跃值
    activeValue: {
      type: Number,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 是否重点活动
      isKeyActivity: 0,
      // 活动投放位置
      placementPosition: [],
      // 用于区分是不是修改数据
      isEdit: false,
      // 默认时间结尾
      defaultStartTime: "00:00:00",
      defaultEndTime: "23:59:59",
      // 活动结束时间规则
      endTimeOption: {
        disabledDate: (time) => {
          // 大于停止参与时间
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            time.getTime() >
              new Date(this.$store.getters.loginUserInfo.expiredIn).valueOf() ||
            (this.formData.stopJoinTime &&
              time.getTime() < new Date(this.formData.stopJoinTime).valueOf())
          );
        },
      },
      // 停止参与时间规则
      stopTimeOption: {
        disabledDate: (time) => {
          // 小于 活动结束时间
          // 大于 派样付款结束时间、派样收货结束时间、回购付款结束时间、回购收货结束时间
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.formData.endTime &&
              time.getTime() >= new Date(this.formData.endTime).valueOf()) ||
            (this.formData.payEndTime &&
              time.getTime() <= new Date(this.formData.payEndTime).valueOf()) ||
            (this.formData.finishEndTime &&
              time.getTime() <=
                new Date(this.formData.finishEndTime).valueOf()) ||
            (this.formData.enterEndTime &&
              time.getTime() <=
                new Date(this.formData.enterEndTime).valueOf()) ||
            (this.formData.rePayEndTime &&
              time.getTime() <=
                new Date(this.formData.rePayEndTime).valueOf()) ||
            (this.formData.reFinishEndTime &&
              time.getTime() <=
                new Date(this.formData.reFinishEndTime).valueOf())
          );
        },
      },
      // --- 派样 ---
      // 派样开始时间规则
      payStartTimeOption: {
        // 小于 派样付款结束时间、停止参与时间、确认收货结束、收货信息录入时间
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.formData.payEndTime &&
              time.getTime() > new Date(this.formData.payEndTime).valueOf()) ||
            (this.formData.stopJoinTime &&
              time.getTime() >
                new Date(this.formData.stopJoinTime).valueOf()) ||
            (this.formData.finishEndTime &&
              time.getTime() >
                new Date(this.formData.finishEndTime).valueOf()) ||
            (this.formData.enterEndTime &&
              time.getTime() > new Date(this.formData.enterEndTime).valueOf())
          );
        },
      },
      // 派样结束时间规则
      payEndTimeOption: {
        // 大于派样付款开始时间、小于停止参与时间
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.formData.payStartTime &&
              time.getTime() <
                new Date(this.formData.payStartTime).valueOf()) ||
            (this.formData.stopJoinTime &&
              time.getTime() > new Date(this.formData.stopJoinTime).valueOf())
          );
        },
      },
      // 派样确认收货结束时间规则
      finishEndTimeOption: {
        // 大于派样收货开始、小于派样结束
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.formData.finishStartTime &&
              time.getTime() <
                new Date(this.formData.finishStartTime).valueOf()) ||
            (this.formData.stopJoinTime &&
              time.getTime() > new Date(this.formData.stopJoinTime).valueOf())
          );
        },
      },
      // 派样录入信息结束时间规则
      enterEndTimeOption: {
        // 大于派样录入开始、小于停止参与时间
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.formData.enterStartTime &&
              time.getTime() <
                new Date(this.formData.enterStartTime).valueOf()) ||
            (this.formData.stopJoinTime &&
              time.getTime() > new Date(this.formData.stopJoinTime).valueOf())
          );
        },
      },

      // --- 回购 ---
      // 回购付款开始时间规则
      rePayStartTimeOption: {
        // 小于回购付款结束、小于停止参与时间
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.formData.rePayEndTime &&
              time.getTime() >
                new Date(this.formData.rePayEndTime).valueOf()) ||
            (this.formData.stopJoinTime &&
              time.getTime() > new Date(this.formData.stopJoinTime).valueOf())
          );
        },
      },
      // 回购付款结束时间规则
      rePayEndTimeOption: {
        // 大于回购付款开始、小于停止参与时间
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.formData.rePayStartTime &&
              time.getTime() <
                new Date(this.formData.rePayStartTime).valueOf()) ||
            (this.formData.stopJoinTime &&
              time.getTime() > new Date(this.formData.stopJoinTime).valueOf())
          );
        },
      },
      reFinishEndTimeOption: {
        // 大于回购收货开始、小于停止参与时间
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 24 * 60 * 60 * 1000 + 1 ||
            (this.formData.reFinishStartTime &&
              time.getTime() <
                new Date(this.formData.reFinishStartTime).valueOf()) ||
            (this.formData.stopJoinTime &&
              time.getTime() > new Date(this.formData.stopJoinTime).valueOf())
          );
        },
      },

      formData: {
        // --- 基本规则 ---
        activityName: "",
        partner: ["-1"],
        isOpenCard: false,
        condFollow: 0,
        // 活动结束时间
        endTime: "",
        // 停止参与时间
        stopJoinTime: "",
        // 活动C端背景图
        picUrl: "",

        // --- 下单派样规则 ---
        payStartTime: "",
        payEndTime: "",
        // 派样商品类型
        sampleProductsType: 0,
        sampleProductList: [],
        // 商品件数
        itemTotal: "",
        // 派样收货时间
        finishStartTime: "",
        finishEndTime: "",
        // 派样录入时间
        enterStartTime: "",
        enterEndTime: "",

        // --- 回购规则 ---
        rePayStartTime: "",
        rePayEndTime: "",
        // 回购商品类型
        reProductList: [],
        reProductsType: 0,
        orderAmt: "",
        // 回购确认收货
        reFinishStartTime: "",
        reFinishEndTime: "",

        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",

        // 活动规则
        ruleDescription: "",
        // 活动页
        explainPicUrl: "",
        jumpLink: "",
        jumpPicUrl: "",
      },
      // jumpPicUrl:
      //   "https://jdminiapp.yucrm.cn/html/images/Proya/suspension_icon.png", // 重置后的按钮悬浮图片地址
      // 会员等级列表
      levelList: [],
      isStart: false,
      // 小程序分享照片 重置数据
      sharePic: "",
      explainPicUrl: "",
      // 表单规则
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            max: 15,
            message: "长度在 15 个字符以内",
            trigger: "blur",
          },
        ],
        ruleDescription: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
        prizeSet: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        choosePrize: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
        prizeSite: [{ required: true, message: " ", trigger: "blur" }],
        information: [{ required: true, message: " " }],
      },
      // 奖品列表
      prizeSettingList: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: 3, // 类型 固定为实物
          price: null, // 价格
          title: "", // 商品标题
          totalAmount: null, // 总共奖品数量
          singleAmount: 1, // 单份奖品数量 固定为1
          logo: null, // 自定义商品图片
        },
      ],
      // 是否打开奖品列表的选择商品弹框
      isShowPiontProduct: false,
      // JingdouCount: {
      //   prizeCount: 0,
      // },
      // typeDefault: {
      //   grantType: 5, // 发放类型  传对应的id值
      //   display: 1, // 是否公开  传对应的id值
      //   type: 0, // 不禁用  传对应的id值
      //   noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      // },
      echoDate: {},
      // itemArr: [],
      // 实物弹框
      isShowSelectGoods: false,
      isShowReSelectGoods: false,
      // 标识活跃商品选项
      actShopType: null,

      // 保存设置提示框
      showSetDialog: false,
      checked: false, //  是否明确活动规则 保存后弹窗内的勾选框
      isCilk: true,
      isDraft: false,
      // 新增派样成功后送券
      coupon: {
        dayNum: 2, //商品发放时机
        sendReBuyPrize: [
          {
            prizeType: 1,
            price: null,
            title: "",
            singleAmount: null,
            totalAmount: null,
            inviteNum: null,
            takeEndTime: null,
            takeBeginTime: null,
            isMain: 1,
            quota: null,
          },
        ], //派样回购奖品
      },
      // 优惠卷弹窗
      addCouponIsShow2: false,
    };
  },
  computed: {
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
    //  自营-1 pop-0
    venderType() {
      return this.$store.getters.loginUserInfo.venderType;
    },
    sellerNick() {
      return this.$store.getters.loginUserInfo.sellerNick;
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    // 丸美悬浮按钮特殊处理
    jumpPicUrl() {
      return this.$store.getters.loginUserInfo.venderId == "1000003788"
        ? "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/suspension_btn.png"
        : this.$store.getters.loginUserInfo.venderId == "1000080364" ||
          this.$store.getters.loginUserInfo.venderId == "69268"
        ? "https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/zj_btn.png"
        : "https://jdminiapp.yucrm.cn/html/images/Proya/suspension_icon.png";
    },
  },
  created() {
    // 获取会员等级
    this.getLevel();
    // console.log("当前活跃", this.activityData);
    // 配置当前分享海报
    // TODO: main.js替换海报
    this.sharePic = this.getDefaultSharePic(this.activityData.id);
    this.formData.sharePic = this.sharePic;
    this.formData.explainPicUrl = this.explainPicUrl;
    this.formData.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.formData.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观~`;
    this.formData.jumpPicUrl = this.jumpPicUrl;
  },
  mounted() {
    // 获取会员等级
    this.getLevel();
    if (this.valueRow) {
      this.isEdit = true;
    } else {
      this.isEdit = false;
    }
    // 设置form表单是否可操作
    this.isStart = this.activityData.isStart
      ? this.activityData.isStart
      : false;
  },
  watch: {
    formData: {
      deep: true,
      immediate: true,
      handler(newVal) {
        // console.log("newVal", newVal);
        // 派样收货开始、派样录入开始 等于 派样付款开始
        // if(newVal.payStartTime){
        this.formData.finishStartTime = newVal.payStartTime;
        this.formData.enterStartTime = newVal.payStartTime;
        // }
        // 回购收货开始 等于 回购付款开始
        // if(newVal.rePayStartTime){
        this.formData.reFinishStartTime = newVal.rePayStartTime;
        // }
        // 参与条件转换
        if (this.formData.isOpenCard) {
          this.formData.condFollow = 1;
        } else {
          this.formData.condFollow = 0;
        }
      },
    },
  },
  methods: {
    //pop店铺获取优惠券信息
    // addStatus1(val) {
    //   console.log("data", val);
    //   this.coupon.sendReBuyPrize[0] = {
    //     ...val,
    //     couponType: 1,
    //   };
    //   console.log(this.coupon.sendReBuyPrize);
    //   this.$forceUpdate();
    // },
    // 自营店获取优惠卷信息
    addStatus2(val, params) {
      let _this = this;
      if (val) {
        // this.coupon.sendReBuyPrize[0] = params;
        let obj = {
          prizeType: 1,
          assetsId: params.assetsId,
          singleAmount: 1,
          title: params.name,
          price: params.discount,
          couponType: params.couponType,
          batchKey: params.couponIdOrPutKey,
          quota: params.quota,
          isMain: 1,
        };
        // this.coupon.sendReBuyPrize[0].prizeType = 1;
        // this.coupon.sendReBuyPrize[0].assetsId = params.assetsId;
        // this.coupon.sendReBuyPrize[0].singleAmount = 1;
        // this.coupon.sendReBuyPrize[0].title = params.name;
        // this.coupon.sendReBuyPrize[0].price = params.discount;
        // this.coupon.sendReBuyPrize[0].couponType = params.couponType;
        // this.coupon.sendReBuyPrize[0].batchKey = params.couponIdOrPutKey;
        // this.coupon.sendReBuyPrize[0].quota = params.quota;
        // this.coupon.sendReBuyPrize[0].isMain = 1;
        this.coupon.sendReBuyPrize.splice(0, 1, obj);
        this.addCouponIsShow2 = false;
        console.log(this.coupon.sendReBuyPrize);
        // _this.$forceUpdate();
      }
    },
    reSendReBuyPrize() {
      let _this = this;
      // this.coupon.sendReBuyPrize = [
      //   {
      //     prizeType: 1,
      //     price: null,
      //     title: "",
      //     singleAmount: null,
      //     totalAmount: "",
      //     inviteNum: null,
      //     takeEndTime: null,
      //     takeBeginTime: null,
      //     isMain: 1,
      //     quota: null,
      //   },
      // ];
      let obj = {
        prizeType: 1,
        price: null,
        title: "",
        singleAmount: null,
        totalAmount: "",
        inviteNum: null,
        takeEndTime: null,
        takeBeginTime: null,
        isMain: 1,
        quota: null,
      };
      this.coupon.sendReBuyPrize.splice(0, 1, obj);
      // _this.$forceUpdate();
    },
    //输入框限制负数
    new_checkputn(value, key) {
      let filtered = value.replace(/[^0-9]/g, "");
      if (filtered == 0) {
        filtered = 1;
      }
      if (filtered > 10) {
        filtered = 10;
      }
      this.coupon[key] = filtered;
      return filtered;
    },
    beAdd(row) {
      if (this.isStart) {
        if (row.totalAmount < row.minNum && row.minNum) {
          row.totalAmount = row.minNum;
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    // 获取会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          this.levelList = [];
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          // 获取活动详情
          if (this.activeValue) {
            this.getDetail();
          }
        })
        .catch((res) => {});
    },
    // 获取活动详情
    getDetail() {
      if (this.valueRow) {
        let id = this.valueRow.id;
        getSendReBuyDetail(id)
          .then((res) => {
            console.log("getSendReBuyDetail", res);
            let rdata = res.data;
            // this.formData = rdata;
            // 数据回显
            this.formData.activityName = rdata.activityName;
            // 活动参与对象
            if (rdata.allowLevel == "1,2,3,4,5") {
              this.formData.partner = ["-1"];
            } else {
              this.formData.partner = rdata.allowLevel.split(",");
            }
            // 参与条件
            if (rdata.condFollow == 1) {
              this.formData.isOpenCard = true;
            } else {
              this.formData.isOpenCard = false;
            }
            this.formData.condFollow = rdata.condFollow;
            this.formData.endTime = rdata.endTime;
            let rule = rdata.ruleDto;
            this.formData.stopJoinTime = rule.stopJoinTime;
            this.formData.sharePic = rule.sharePic;
            this.formData.shareIntroduce = rule.shareIntroduce;
            this.formData.shareTitle = rule.shareTitle;
            this.formData.explainPicUrl = rule.explainPicUrl;
            this.formData.picUrl = rule.picUrl;
            this.formData.jumpLink = rule.jumpLink;
            this.formData.jumpPicUrl = rule.jumpPicUrl;
            this.formData.ruleDescription = rdata.ruleDescription;
            this.isKeyActivity = rdata.isKeyActivity || 0;
            this.placementPosition = rdata.placementPosition ? rdata.placementPosition.split(",") : ["SHOP"];

            // 派样
            let sendRule = rule.sendRule;
            this.formData.payStartTime = sendRule.payStartTime;
            this.formData.payEndTime = sendRule.payEndTime;
            this.formData.sampleProductsType = sendRule.skuType;
            let sendSku = sendRule.skuIds;
            this.formData.sampleProductList = [];
            let sampleProductList = [];
            // 查询对应商品信息
            getTaobaoItemListSku({
              current: 1,
              size: 9999999,
              skuIdStr: sendSku.join(","),
            })
              .then((res) => {
                if (res.code == 1) {
                  sampleProductList = res.data.records;
                  this.formData.sampleProductList = sampleProductList;
                } else {
                  this.$message.error(res.message);
                  this.formData.sampleProductList = [];
                }
              })
              .catch((err) => {
                this.$message.error(err);
                this.formData.sampleProductList = [];
              });
            this.formData.itemTotal = sendRule.itemTotal;
            this.formData.finishStartTime = sendRule.finishStartTime;
            this.formData.finishEndTime = sendRule.finishEndTime;
            this.formData.enterStartTime = sendRule.enterStartTime;
            this.formData.enterEndTime = sendRule.enterEndTime;

            // 回购
            let reRule = rule.reBuyRule;
            this.formData.rePayStartTime = reRule.payStartTime;
            this.formData.rePayEndTime = reRule.payEndTime;
            this.formData.reProductsType = reRule.skuType;
            // 商品集合
            this.formData.reProductList = [];
            let reProductList = [];
            let reSku = reRule.skuIds;
            // 查询对应商品信息
            getTaobaoItemListSku({
              current: 1,
              size: 9999999,
              skuIdStr: reSku.join(","),
            })
              .then((res) => {
                if (res.code == 1) {
                  reProductList = res.data.records;
                  this.formData.reProductList = reProductList;
                } else {
                  this.$message.error(res.message);
                  this.formData.reProductList = [];
                }
              })
              .catch((err) => {
                this.$message.error(err);
                this.formData.reProductList = [];
              });

            this.formData.orderAmt = String(reRule.amt);
            this.formData.reFinishStartTime = reRule.finishStartTime;
            this.formData.reFinishEndTime = reRule.finishEndTime;

            let _this = this;
            // 奖品
            this.prizeSettingList = rdata.pointActivityPrizeDTOList;
            // 优惠卷
            if (rdata.sendReBuyPrize) {
              // this.coupon.sendReBuyPrize[0] = rdata.sendReBuyPrize;
              this.coupon.sendReBuyPrize.splice(0, 1, rdata.sendReBuyPrize);
              this.coupon.dayNum = rdata.ruleDto.sendRule.dayNum;
              // _this.$forceUpdate();
            }
          })
          .catch((err) => {
            console.log("获取活动详情", err);
          });
      }
    },
    totalAmountInput($event, scope) {
      let _this = this;
      let obj = scope.row;
      obj.totalAmount = this.getNumberData(1, $event, 0, 1, 99999999);
      this.coupon.sendReBuyPrize.splice(0, 1, obj);
      // scope.row.totalAmount = this.getNumberData(1, $event, 0, 1, 99999999);
      // _this.$forceUpdate();
    },
    // 会员等级改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.formData.partner = ["-1"];
        }
      });
    },
    // -------------图片部分开始----------------
    // 上传图片前校验 （不校验尺寸，只校验大小和格式）
    // C端背景图、活动页说明图
    beforeUpload(file) {
      let _this = this;
      let image = new Image();
      let _URL = window.URL || window.webkitURL;
      image.onload = function() {
        const valid = true;
        file.isFlag = valid;
        if (valid) {
        } else {
          _this.$message.info("图片尺寸不符合要求，请重新上传");

          return false;
        }
      };
      image.src = _URL.createObjectURL(file);
      const isLt3M = file.size < 1024 * 300;
      if (!isLt3M) {
        this.$message.info("图片大小不符合要求，请重新上传");
        return false;
      }
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      if (sorts.indexOf(type) < 0) {
        this.$message.info("图片格式不符合要求，请重新上传");
        return false;
      }
    },
    // 小程序分享照片 需要校验尺寸
    async beforeUpload2(file) {
      let _this = this;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];

      if (sorts.indexOf(type) < 0) {
        this.$message.info("图片格式不符合要求，请重新上传");
        await Promise.reject();
        return false;
      }
      await this.imgchecked(file, 200, 200);
      const isLt3M = file.size < 1024 * 300;
      if (!isLt3M) {
        this.$message.info("图片大小不符合要求，请重新上传");
        await Promise.reject();
        return false;
      }
    },

    //上传图片前校验   悬浮按钮设置
    async beforeUpload3(file) {
      let _this = this;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];

      if (sorts.indexOf(type) < 0) {
        this.$message.info("图片格式不符合要求，请重新上传");
        await Promise.reject();
        return false;
      }
      await this.imgchecked(file, 150, 150);
      console.log(file);
      const isLt3M = file.size < 1024 * 100;
      if (!isLt3M) {
        this.$message.info("图片大小不符合要求，请重新上传");
        await Promise.reject();
        return false;
      }
    },

    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let image = new Image();
        let _URL = window.URL || window.webkitURL;
        image.onload = function() {
          const valid = image.width == width && image.height == height;
          file.isFlag = valid;
          if (valid) {
            resolve();
          } else {
            _this.$message.info("图片尺寸不符合要求，请重新上传");
            reject();
          }
        };
        image.src = _URL.createObjectURL(file);
      });
    },
    // C端背景图 - 上传成功回调
    handleUpload(res) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        this.formData.picUrl = res.data;
      }
    },
    // 小程序分享图片 - 上传成功回调
    handleUpload1(res) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        this.formData.sharePic = res.data;
      }
    },
    // 活动页说明图 - 上传成功回调
    handleUpload2(res) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        this.formData.explainPicUrl = res.data;
      }
    },
    // 上传成功  悬浮按钮设置
    handleUpload3(res) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        this.formData.jumpPicUrl = res.data;
      }
    },

    // 重置图片  悬浮按钮设置
    picUrlReset3() {
      if (this.activityData.isStart) return;
      this.formData.jumpPicUrl = this.jumpPicUrl;
    },

    // 小程序分享图片重置
    picUrlReset1() {
      if (this.isStart) return;
      this.formData.sharePic = this.sharePic;
    },
    // -------------图片部分结束----------------
    // 派样商品监听
    handleProductsType() {
      if (this.isStart) return;
      this.formData.sampleProductList = [];
    },
    //输入框限制负数
    checkputn(value, key) {
      let filtered = value.replace(/[^0-9]/g, "");
      if (filtered.indexOf(0) == 0) {
        filtered = "";
      }
      this.formData[key] = filtered;
      return filtered;
    },
    handelInput(dataName) {
      let inputValue = this.formData[`${dataName}`];

      // 除数字和小数点之外
      inputValue = inputValue.replace(/^\d[0,9]\.[0-9]{2}?$/, "");

      // 限制小数点后两位
      const parts = inputValue.split(".");
      if (parts[0].length > 1 && parts[0].charAt(0) == "0") {
        parts[0] = parts[0].substring(1);
      }
      if (parts.length > 1) {
        parts[1] = parts[1].slice(0, 2);
        inputValue = parts[0] + "." + parts[1];
      } else {
        inputValue = parts[0];
      }
      let value = isNaN(inputValue) ? "" : inputValue.toString();
      // 更新数据
      if (inputValue < 999999) {
        this.formData[`${dataName}`] = value;
      } else {
        this.formData[`${dataName}`] = "999999";
        this.$message.warning("不能大于999999");
      }
    },
    // handleInput2(valueName) {
    //   let inputValue = this.formData[`${dataName}`];
    //   inputValue = inputValue.replace(/[^\d.]/g, '');
    //   inputValue = inputValue.replace(/^\./, '');
    //   inputValue = inputValue.replace(/\.{2,}/g, '.');

    //   // 限制小数位数为两位
    //   const parts = inputValue.split(".");
    //   if (parts[0].length > 1 && parts[0].charAt(0) == "0") {
    //     parts[0] = parts[0].substring(1);
    //   }
    //   if (parts.length > 1) {
    //     parts[1] = parts[1].slice(0, 2);
    //     inputValue = parts[0] + "." + parts[1];
    //   } else {
    //     inputValue = parts[0];
    //   }

    //   // 限制为大于等于0的正整数
    //   if (inputValue.charAt(0) === '.' || inputValue.charAt(0) === '0') {
    //     inputValue = inputValue.replace(/^0+/, '');
    //   }
    //   let value = isNaN(inputValue) ? "" : inputValue.toString();
    //   // 更新数据
    //   this.formData[`${dataName}`] = value;
    // },
    // 回购商品监听
    handleReProductsType() {
      if (this.isStart) return;
      // 如果选了全部商品，就清空集合
      this.formData.reProductList = [];
    },
    // 获取奖品
    getTheData(data, prizeType) {
      console.log(data, prizeType, "data");
      this.isShowPiontProduct = false;
      this.prizeSettingList[0].assetsId = data.skuId;
      // 奖品类型
      this.prizeSettingList[0].prizeType = prizeType;
      this.prizeSettingList[0].price = Number(data.discount);
      this.prizeSettingList[0].title = data.name;
      this.prizeSettingList[0].logo = data.logo;
    },
    // 奖品表格选择
    centerVis(row) {
      // 无操作权限则返回
      if (this.isStart) return;
      // this.itemArr = this.prizeSettingList;
      this.echoDate = row;
      // this.JingdouCount.prizeCount = row.prizeCount;
      this.isShowPiontProduct = true;
      this.$refs.selectPiontProduct.openDialog();
    },
    // 优惠卷选择
    handleChoise(row) {
      // if (this.$store.getters.loginUserInfo.venderId == "69268") {
      //   this.addCouponIsShow1 = true;
      //   this.echoDate = row.innerCouponDto ? row.innerCouponDto : {};
      // } else {
      //   this.addCouponIsShow2 = true;
      // }
      this.addCouponIsShow2 = true;
    },
    colseDialog() {
      this.isShowPiontProduct = false;
      this.clickActual = false;
    },
    // 生成规则
    generateRule() {
      // if(this.venderType == 0) {
      // POP
      this.createPopRule();
      // }else if(this.venderType == 1) {
      // 自营
      // }else {
      // this.$message.error("未登录，无法判断店铺类型");
      // }
    },
    createPopRule() {
      // 店铺名称
      let sellerNickName = this.sellerNick;
      let completeRules = "";
      // 顶部时间，活动奖品，如何参与活动、如何获奖
      let textObj = "",
        eventPrizesText = "",
        addActiveText = "",
        awardsText = "",
        noteText = "";
      // ------顶部时间----开始
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "";
      if (!!this.formData.payStartTime && !!this.formData.payEndTime) {
        text1 = this.formData.payStartTime + " ~ " + this.formData.payEndTime;
      }
      if (!!this.formData.finishStartTime && !!this.formData.finishEndTime) {
        text2 =
          this.formData.finishStartTime + " ~ " + this.formData.finishEndTime;
      }
      if (!!this.formData.rePayStartTime && !!this.formData.rePayEndTime) {
        text3 =
          this.formData.rePayStartTime + " ~ " + this.formData.rePayEndTime;
      }
      if (
        !!this.formData.reFinishStartTime &&
        !!this.formData.reFinishEndTime
      ) {
        text4 =
          this.formData.reFinishStartTime +
          " ~ " +
          this.formData.reFinishEndTime;
      }
      if (!!this.formData.enterStartTime && !!this.formData.enterEndTime) {
        text5 =
          this.formData.enterStartTime + " ~ " + this.formData.enterEndTime;
      }
      if (!!this.formData.endTime) {
        text6 = this.formData.endTime;
      }
      textObj = `<p>活动时间（以北京时间为准）</p><p>尝鲜礼付款时间：${text1}</p><p>尝鲜礼确认收货时间：${text2}</p><p>正装回购付款时间：${text3}</p><p>正装回购确认收货时间：${text4}</p><p>填写收货信息时间：${text5}</p><p>活动页面关闭时间：${text6}</p>
      `;

      // ------活动奖品----开始
      let priceItem = this.prizeSettingList[0];
      let sendReBuyPrizeData = this.coupon.sendReBuyPrize[0];
      let result = "";
      if (!!priceItem.title) {
        result = priceItem.title;
      }
      // 尝鲜礼奖品
      let sendReBuyPrizeShow =
        sendReBuyPrizeData.title &&
        sendReBuyPrizeData.totalAmount &&
        this.permissions.indexOf("hide:hd:prize:sendReBuyPrize") != "-1";
      // 奖品数量
      let totalAmount = !!priceItem.totalAmount ? priceItem.totalAmount : " ";
      eventPrizesText = `<p>一、【活动奖品】</p>${
        sendReBuyPrizeShow
          ? `<p>尝鲜礼奖品：${sendReBuyPrizeData.title}，<strong style="color:red;">限量${sendReBuyPrizeData.totalAmount}份</strong>，1张/份，价值：满${sendReBuyPrizeData.quota}减${sendReBuyPrizeData.price}元</p>`
          : ""
      }<p>活动奖品：${result}，<strong style="color:red;">限量${totalAmount}份</strong>。</p><p>*活动期间，<strong style="color:red;">奖品同一用户限量1份（即购买多件指定尝鲜礼或回购多件指定正装，奖品限发1份）</strong>，奖品数量有限，先到先得，送完即止。</p>`;

      // ------如何参与活动----开始
      let orderAmt = !!this.formData.orderAmt ? this.formData.orderAmt : " ";
      addActiveText = `<p>二、【如何参与活动】</p><p>1.用户须为京东【${sellerNickName}】的会员，并在整个活动时间内未操作退出会员。</p><p>2.会员于尝鲜礼付款阶段，在京东【${sellerNickName}】进行指定尝鲜礼付款，并预填收货地址。<strong style="color:red;">尝鲜礼库存有限，卖完恢复日常价，活动期间每个尝鲜礼每IP/UDID/账号限购1单且每单限购1个，</strong>且购买多件尝鲜礼，活动奖品限发1份。</p><p>注：尝鲜礼付款商品范围详见#指定活动商品#</p><p>3.会员完成尝鲜礼付款和收货信息填写后于正装回购付款阶段（预售订单的正装回购付款时间以尾款付款时间为准），在京东【${sellerNickName}】进行指定正装产品付款，且单笔订单金额达到${orderAmt}元（金额不含退款）。</p><p>注：回购付款商品范围详见 #指定活动商品#</p><p>4.用户在规定的确认收货时间内<strong style="color:red;">完成尝鲜礼订单和回购正装订单的收货且已填写收货信息，即完成活动参与，</strong>如经审查符合参与条件且在前${totalAmount}名内，即可锁定奖品等待发奖。奖品数量有限，先到先得，送完即止。</p>`;

      // ------如何获奖----开始
      awardsText = `<p>三、【如何获奖】</p><p>1.用户需在指定的确认收货时间内完成尝鲜礼订单和回购正装订单的收货，在指定填写收货信息时间内完成收货信息的录入。</p><p>2.尝鲜礼订单付款成功后将会提示预填收货信息，<strong style="color:red;">信息一经提交仅支持修改一次，</strong>后续无法修改。订单满足活动要求的用户，<strong style="color:red;">奖品将于填写收货信息时间结束后30个工作日内，按照用户提供的收货信息通过快递形式发出</strong>（如遇疫情等不可抗因素，将相应延迟发放）。1）如果没有提前预填收货信息，可在活动主页【活动记录-收货信息】位置填写相关信息，且须于填写收货信息截止时间前完成填写，逾期视为放弃领奖资格。2）如果收货信息填写错误，须于填写收货信息截止时间前完成修改，若因逾期未改或最终地址依然有误而导致无法发货或无法送达，视为放弃领奖资格，商家无法支持补发。</p><p>3.用户<strong style="color:red;">在活动期间不可操作退出京东【${sellerNickName}】的会员身份，</strong>若中途退出则失去获奖资格，再次入会也无法恢复资格。</p><p>4.如成功参与活动的<strong style="color:red;">用户对商品订单进行退款处理，导致实际确认收货商品或金额不足活动条件，视为用户不符合兑换奖品资格，商家有权取消该用户获取奖品的资格。</strong>同一用户多个订单满足活动要求，也仅可获得1份奖品。同一用户的定义详见注意事项。</p><p>5.由于活动奖品数量有限，系统根据用户活动期内符合要求的首笔已确认收货的尝鲜礼订单的确认收货时间及首笔已确认收货的指定回购正装订单的确认收货时间的后一时间为准选取前${totalAmount}名，如果最后一份奖品排序时间出现同一时间点内有多个用户满足发奖要求，则会采取系统随机的方式进行抽取。</p>`;

      // -----注意事项----开始---
      noteText = `<p>四、【注意事项】</p><p>1.同一用户仅限参与活动一次。同一用户是指账户、手机号码、收件地址、支付账号、身份证号码、设备标识符、注册信息、网络操作日志、交易订单信息等与用户身份和行为相关的信息，其中任意一项或数项存在相同、相似，亦或通过特定标记批量信息进行分析，其数项存在相同、相似的（包括但不限于批量相同、雷同、邻近、虚构的地址）均视为同一用户。同一用户注册、持有、使用或控制多个会员账号，商家有权取消/限制其参与本活动或领取奖品的资格。</p><p>2.活动期间，若发现用户使用或曾使用不正当方式（包括但不限于批量注册，恶意套现，虚假分享，虚假交易，网络攻击，众包作弊，通过任何外挂软件破坏、规避活动规则）或仅以套取活动利益为目的参与本次活动，不符合活动公平、诚信原则的，商家有权直接取消或限制用户参与活动的资格；若用户已领取奖品奖励，商家有权追回（包括但不限于取消违反规则而形成的订单、奖励）；出现前述情形之一的，商家有权将视情况终止、限制用户后续参与商家任意活动的资格，并保留追究其法律责任的权利。</p><p>3.活动期间，如出现不可抗力或形势变更的情况，包括但不限于重大灾害事件、黑客攻击、系统故障、活动受政府机关指令需停止举办或调整本活动的，商家可依据相关法律法规的规定调整或暂停或提前终止活动。</p><p>4. 本活动所发放的所有奖品不可折现、不可转赠他人、不可为他人付款、不支持开具发票。</p><p>5. 实物奖品一经发出，无质量问题恕不退换，如有疑问，请咨询店铺客服。</p><p>6.商家可根据活动的实际进行情况，在法律允许的范围内，对本活动规则进行调整或变动，相关调整或变动将公布在活动规则页上。</p><p>7.如对本活动有任何疑问，请咨询在线客服。</p>`;
      completeRules =
        textObj +
        "<br/>" +
        eventPrizesText +
        "<br/>" +
        addActiveText +
        "<br/>" +
        awardsText +
        "<br/>" +
        noteText;
      this.formData.ruleDescription = completeRules;
    },
    // 保存设置
    vaildForm() {
      console.log("点击了保存", this.formData);
      // 活动名称
      if (!this.formData.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      // 活动参与对象
      if (this.formData.partner.length <= 0) {
        this.$message.warning("请选择活动参与对象");
        return;
      }
      // 活动结束时间
      if (!this.formData.endTime) {
        this.$message.warning("请输入活动结束时间");
        return;
      }
      // 停止参与时间
      if (!this.formData.stopJoinTime) {
        this.$message.warning("请输入停止参与时间");
        return;
      }
      // 活动C端背景图
      if (!this.formData.picUrl) {
        this.$message.warning("请上传活动C端背景图");
        return;
      }

      // 下单派样
      if (!this.formData.payStartTime || !this.formData.payEndTime) {
        this.$message.warning("请补充下单派样付款时间");
        return;
      }

      if (
        this.formData.sampleProductsType == 1 &&
        this.formData.sampleProductList.length <= 0
      ) {
        this.$message.warning("请添加派样商品");
        return;
      }

      if (
        this.formData.sampleProductsType == 2 &&
        this.formData.sampleProductList.length <= 0
      ) {
        this.$message.warning("请添加派样商品");
        return;
      }

      if (!this.formData.itemTotal) {
        this.$message.warning("请输入商品件数");
        return;
      }
      if (!this.formData.finishStartTime || !this.formData.finishEndTime) {
        this.$message.warning("请补充派样确认收货时间");
        return;
      }
      if (!this.formData.enterStartTime || !this.formData.enterEndTime) {
        this.$message.warning("请补充派样收货信息录入时间");
        return;
      }

      // 回购
      if (!this.formData.rePayStartTime || !this.formData.rePayEndTime) {
        this.$message.warning("请补充回购付款时间");
        return;
      }
      if (
        this.formData.reProductsType == 1 &&
        this.formData.reProductList.length <= 0
      ) {
        this.$message.warning("请选择回购活动商品");
        return;
      }

      if (
        this.formData.reProductsType == 2 &&
        this.formData.reProductList.length <= 0
      ) {
        this.$message.warning("请选择回购活动商品");
        return;
      }
      if (this.formData.orderAmt == "") {
        this.$message.warning("请输入单笔订单金额");
        return;
      }
      if (!this.formData.reFinishStartTime || !this.formData.reFinishEndTime) {
        this.$message.warning("请补充回购确认收货时间");
        return;
      }

      // 奖品设置
      if (!this.prizeSettingList[0].title) {
        this.$message.warning("请选择奖品");
        return;
      }
      if (!this.prizeSettingList[0].totalAmount) {
        this.$message.warning("请输入奖品总数");
        return;
      }

      // 分享设置
      if (!this.formData.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      if (!this.formData.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.formData.sharePic) {
        this.$message.warning("请上传小程序分享照片");
        return;
      }

      // 活动规则
      if (
        !this.formData.ruleDescription ||
        this.formData.ruleDescription == "<p><br></p>"
      ) {
        this.$message.warning("请输入活动规则");
        return;
      }

      // 优惠卷
      if (
        this.coupon.sendReBuyPrize[0].name &&
        !this.coupon.sendReBuyPrize[0].totalAmount
      ) {
        this.$message.warning("请输入发放数量");
        return;
      }
      if(this.placementPosition.length==0) {
        this.$message.warning("请选择活动投放位置！");
        return
      }
      
      // 活动页说明页
      // if (!this.formData.explainPicUrl) {
      //   this.$message.warning("请上传活动页说明页");
      //   return;
      // }

      // 打开提示框
      this.showSetDialog = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.formData.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    handleDialogCloseAnoth() {
      if (this.checked || this.isDraft) {
        // 发送请求关闭弹框
        // console.log("formData", this.formData);
        let sendSkuArr = [];
        this.formData.sampleProductList.forEach((item) => {
          sendSkuArr.push(item.skuId);
        });
        let reSkuArr = [];
        this.formData.reProductList.forEach((item) => {
          reSkuArr.push(item.skuId);
        });
        let sendSkuId = sendSkuArr;
        let reSkuId = reSkuArr;
        console.log("sendSkuId------>", sendSkuId);
        let allowLevel = null;
        let arr = this.formData.partner;
        allowLevel = this.formData.partner.join(",");
        arr.forEach((item) => {
          if (item == "-1") {
            allowLevel = "1,2,3,4,5";
          }
        });
        // console.log("allowLevel", allowLevel);
        // 发送请求提交表单
        // 请求参数处理
        let params = {
          // 空为创建
          pointActivityId: this.isEdit ? this.valueRow.id : "",
          activityName: this.formData.activityName,
          allowLevel: allowLevel,
          condFollow: this.formData.condFollow,
          startTime: this.formData.payStartTime,
          endTime: this.formData.endTime,
          // 规则
          ruleDTO: {
            picUrl: this.formData.picUrl,
            stopJoinTime: this.formData.stopJoinTime,
            // 分享设置
            shareTitle: this.formData.shareTitle,
            shareIntroduce: this.formData.shareIntroduce,
            sharePic: this.formData.sharePic,
            // 活动页
            explainPicUrl: this.formData.explainPicUrl,
            // 悬浮图设置
            jumpLink: this.formData.jumpLink,
            jumpPicUrl: this.formData.jumpPicUrl,

            // 下单派样
            sendRule: {
              payStartTime: this.formData.payStartTime,
              payEndTime: this.formData.payEndTime,
              skuType: this.formData.sampleProductsType,
              skuIds: sendSkuId,
              itemTotal: this.formData.itemTotal,
              finishStartTime: this.formData.finishStartTime,
              finishEndTime: this.formData.finishEndTime,
              enterStartTime: this.formData.enterStartTime,
              enterEndTime: this.formData.enterEndTime,
              // dayNum: this.coupon.dayNum,
            },
            // 回购规则
            reBuyRule: {
              payStartTime: this.formData.rePayStartTime,
              payEndTime: this.formData.rePayEndTime,
              skuType: this.formData.reProductsType,
              skuIds: reSkuId,
              finishStartTime: this.formData.reFinishStartTime,
              finishEndTime: this.formData.reFinishEndTime,
              amt: Number(this.formData.orderAmt),
            },
          },
          // 活动规则
          ruleDescription: this.formData.ruleDescription,
          // 奖品设置
          pointActivityPrizeDTOList: this.prizeSettingList,
          // 是否重点活动
          isKeyActivity: this.isKeyActivity,
          placementPosition: this.placementPosition.join(","),
        };
        if (this.permissions.indexOf("hide:hd:prize:sendReBuyPrize") != "-1") {
          // 优惠卷
          if (this.coupon.sendReBuyPrize[0].assetsId) {
            params.sendRebuyPrize = this.coupon.sendReBuyPrize[0];
          }
          params.ruleDTO.sendRule.dayNum = this.coupon.dayNum;
        }
        if (this.isCilk) {
          this.isCilk = false;
          if (this.isDraft) {
            params.status = 5;
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            params.id = this.valueRow.id;
            delete params.pointActivityId;
          }
          if (this.activityData.isCopy) {
            delete params.id;
          }
          saveActivity(params)
            .then((res) => {
              // console.log("res", res);
              if (res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.showSetDialog = false;
                  this.isCilk = true;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                      isEdit: false,
                    },
                  });
                }
              } else {
                this.$message.error(res.message);
                this.isCilk = true;
              }
            })
            .catch((err) => {
              console.log("saveActivity报错", err);
              this.isCilk = true;
            });
        }
      } else {
        this.$message.error("请勾选明确活动规则后即可创建");
      }
    },
    // 选择商品回显
    selectGoodsChange(data) {
      console.log(data);
      if (data) {
        this.formData.sampleProductList = data;
      }
      this.isShowSelectGoods = false;
    },
    // 选择商品回显
    selectReGoodsChange(data) {
      if (data) {
        this.formData.reProductList = data;
      }
      this.isShowReSelectGoods = false;
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id && !this.activityData.isCopy) {
        this.$emit("returnBack");
        return;
      }
      this.$emit("returnBack");
    },
    // 停止参与时间
    handleStopJoinTIme(val) {
      this.formData.stopJoinTime = val;
      if (!!this.formData.endTime) {
        if (
          new Date(this.formData.stopJoinTime) >=
          new Date(this.formData.endTime)
        ) {
          this.$message.error("不能大于等于活动结束时间");
          this.formData.stopJoinTime = "";
        }
      } else if (!!this.formData.endpayEndTimeTime) {
        if (
          new Date(this.formData.stopJoinTime) <=
          new Date(this.formData.payEndTime)
        ) {
          this.$message.error("不能小于等于派样付款结束时间");
          this.formData.stopJoinTime = "";
        }
      } else if (!!this.formData.finishEndTime) {
        if (
          new Date(this.formData.stopJoinTime) <=
          new Date(this.formData.finishEndTime)
        ) {
          this.$message.error("不能小于等于派样确认收货结束时间");
          this.formData.stopJoinTime = "";
        }
      } else if (!!this.formData.enterEndTime) {
        if (
          new Date(this.formData.stopJoinTime) <=
          new Date(this.formData.enterEndTime)
        ) {
          this.$message.error("不能小于等于派样收货信息录入结束时间");
          this.formData.stopJoinTime = "";
        }
      } else if (!!this.formData.rePayEndTime) {
        if (
          new Date(this.formData.stopJoinTime) <=
          new Date(this.formData.rePayEndTime)
        ) {
          this.$message.error("不能小于等于回购付款结束时间");
          this.formData.stopJoinTime = "";
        }
      } else if (!!this.formData.reFinishEndTime) {
        if (
          new Date(this.formData.stopJoinTime) <=
          new Date(this.formData.reFinishEndTime)
        ) {
          this.$message.error("不能小于等于回购确认收货结束时间");
          this.formData.stopJoinTime = "";
        }
      }
    },
    // 派样付款结束限制
    handlePayEndTime(val) {
      this.formData.payEndTime = val;
      // console.log(this.formData.rePayEndTime, this.formData.stopJoinTime);
      if (!!this.formData.stopJoinTime) {
        if (
          new Date(this.formData.payEndTime) >=
          new Date(this.formData.stopJoinTime)
        ) {
          this.$message.error("不能大于等于停止参与时间");
          this.formData.payEndTime = "";
        }
      }
    },
    handleFinishTime(val) {
      if (!!this.formData.stopJoinTime) {
        if (
          new Date(this.formData.finishEndTime) >=
          new Date(this.formData.stopJoinTime)
        ) {
          this.$message.error("不能大于等于停止参与时间");
          this.formData.finishEndTime = "";
        }
      }
    },
    // 派样付款结束限制
    handleRePayEndTime(val) {
      this.formData.rePayEndTime = val;
      if (!!this.formData.stopJoinTime) {
        if (
          new Date(this.formData.rePayEndTime) >=
          new Date(this.formData.stopJoinTime)
        ) {
          this.$message.error("不能大于等于停止参与时间");
          this.formData.rePayEndTime = "";
        }
      }
    },
    handleEnterTime(val) {
      if (!!this.formData.stopJoinTime) {
        if (
          new Date(this.formData.enterEndTime) >=
          new Date(this.formData.stopJoinTime)
        ) {
          this.$message.error("不能大于等于停止参与时间");
          this.formData.enterEndTime = "";
        }
      }
    },
    handlereFinishEndTimeTime(val) {
      if (!!this.formData.stopJoinTime) {
        if (
          new Date(this.formData.reFinishEndTime) >=
          new Date(this.formData.stopJoinTime)
        ) {
          this.$message.error("不能大于等于停止参与时间");
          this.formData.reFinishEndTime = "";
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.item-wrap {
  display: flex;
  align-items: center;
}
.createSemdReBuy {
  min-width: 800px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  background-color: #fff;
  border-radius: 6px;
  margin: -24px;
  margin-bottom: 24px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
    }
  }
  .firststep {
    min-height: 720px;
    box-sizing: border-box;
    padding: 35px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #7b61ff;
            border-bottom: 1px solid #7b61ff;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #7b61ff;
            border-left: 1px solid #7b61ff;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          width: 206px;
          &:hover {
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;
    .zd {
      width: 360px;
    }
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .limit {
      display: flex;
      flex-direction: column;
      p {
        margin: 0;
        &:nth-child(2) {
          margin: 16px 0;
        }
      }
      .c {
        color: #7b61ff;
      }
      .desc {
        i {
          opacity: 0.7;
          color: #7b61ff;
        }
        color: #999;
      }
      /deep/ .el-input {
        margin: 0 6px;
      }
    }
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #eeeeee;
    }
    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 13px 30px;
      background: #fffaee;
      font-size: 13px;
      color: #333;
      i {
        color: #fe8f8a;
        opacity: 0.7;
      }
      p {
        margin: 0;
        line-height: 20px;
        padding-left: 18px;
      }
    }
    .generate {
      width: 76px;
      margin-top: 8px;
      background: rgba(127, 133, 233, 0.1);
      border: 1px solid rgba(127, 133, 233, 1);
      color: #7f85e9;
    }
    .termAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      color: #333;
      p {
        margin: 0;
      }
      .add {
        margin-left: 4px;
        color: #7b61ff;
      }
    }
    .set {
      display: inline-block;
      margin-top: 30px;
    }
    .desc {
      margin-left: 20px;
      color: #999;
      font-size: 13px;
      i {
        color: #fe8f8a;
        opacity: 0.7;
        font-size: 13px;
      }
    }
    .s {
      color: #7b61ff;
      cursor: pointer;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid #7b61ff;
      color: #7b61ff;
      transition: all 0.2s;
      &:hover {
        background-color: #7b61ff;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #7b61ff;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
    .red {
      color: red;
      margin-left: 10px;
    }
    .createRlueBtn {
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #7b61ff;
      background: #f2efff;
      border: 1px solid #7b61ff;
      &:hover {
        color: #fff;
        background: #7b61ff;
      }
    }
    .createRlueTip {
      color: #aaaaaa;
      font-size: 13px;
      margin-left: 12px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(127, 133, 233, 0.1);
      border: 1px solid rgba(127, 133, 233, 1);
      color: #7f85e9;
    }
    /deep/ .el-table .el-table__header-wrapper th .cell {
      text-align: center;
      font-weight: 500;
    }
    /deep/ .el-table .el-table__header-wrapper th {
      border-right: 1px solid #f0f0f0;
      &:last-child {
        border-right: none;
      }
    }
    /deep/ .el-table--enable-row-transition .el-table__body td {
      text-align: center;
      border-right: 1px solid #f0f0f0;
      &:last-child {
        border-right: none;
      }
    }
  }
}
.wrapper-kaika {
  width: 100%;
  height: 100%;
  display: grid;
  // align-items: center;
  // justify-content: center;

  .wrapper-kaika-img {
    background-color: #fafafa;
    border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
    border-radius: 8px;
    height: 350px;
    // margin-right: 20px;
    position: relative;
    &:hover {
      .borderkaika::before,
      .borderkaika::after {
        opacity: 1;
        transform: scale(1);
      }
    }
    .borderkaika {
      position: absolute;
      left: -6px;
      top: -6px;
      width: 218px;
      height: 360px;
      border-radius: 4px;
      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }
      &::before {
        border-top: 1px solid #7b61ff;
        border-bottom: 1px solid #7b61ff;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }
      &::after {
        border-right: 1px solid #7b61ff;
        border-left: 1px solid #7b61ff;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    div {
      font-size: 18px;
      font-weight: bold;
      // line-height: 25px;
      color: #333333;
    }
    img {
      width: 32px;
      height: 32px;
    }

    .queryIdIMG {
      display: none;
    }
    &:hover {
      .queryIdIMG {
        display: block;
      }
      .mask {
        opacity: 1;
      }
    }
    .mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      opacity: 0;
      transition: all 0.2s;
      .img {
        max-width: 130px;
        margin: 0 auto 30px;
        .imgBg {
          box-sizing: border-box;
          height: 129px;
          width: 129px;
          padding: 6px;
          border-radius: 6px;
          background-color: #fff;
        }
        .tpl {
          display: inline-block;
          font-size: 14px;
          color: #fff;
          margin-top: 10px;
          // opacity: 0.7;
        }
      }
    }
  }
  .wrapper-kaika-tanchuang {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .lijijq {
    &::after {
      content: "立即领取";
      display: block;
      position: absolute;
      bottom: 9px;
      left: 51%;
      transform: translateX(-50%);
      font-size: 14px;
      font-family: system-ui;
      font-weight: bold;
      color: #ed6e09;
      text-shadow: 0 0 black;
    }
  }
}
.miniAppPic {
  position: relative;
  .image-slot {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i {
      font-size: 30px;
      color: #909399;
    }
  }
  .top {
    position: relative;
    left: 0px;
    display: flex;
    .returnBtn {
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #7b61ff;
      background: rgba(123, 97, 255, 0.1);
      border: 1px solid #7b61ff;
      &:hover {
        color: #fff;
        background: #7b61ff;
      }
    }
    .reset {
      // color: #7b61ff;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottom {
    position: relative;
    top: 15px;
    .elImg {
      width: 120px;
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips1 {
      position: absolute;
      left: 135px;
      top: 22px;
      line-height: 2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}

/deep/ .createSemdReBuy {
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
</style>
